// import { TrackDetail } from "frontend/src/shared/types/track";
import { useTrackEdit } from "frontend/src/domain/tracks";
import { pause, resume } from "frontend/src/features/control-audio";
export var useTrack = function (initial) {
    var track = useTrackEdit(initial);
    var change = {
        artist: function (evt) {
            return track.artist.set(evt.target.value);
        },
        title: function (evt) {
            return track.title.set(evt.target.value);
        },
        client: function (client) { var _a; return track.client_id.set((_a = client === null || client === void 0 ? void 0 : client.id) !== null && _a !== void 0 ? _a : null); },
        is_approved: function (evt) {
            return track.published.set(evt.target.checked);
        },
    };
    var update = function (evt) {
        evt.preventDefault();
        track.update.run();
    };
    return {
        artist: {
            value: track.artist.value,
            error: track.artist.error.message,
            onChange: change.artist,
        },
        title: {
            value: track.title.value,
            error: track.title.error.message,
            onChange: change.title,
        },
        clientId: { value: track.client_id.value, onChange: change.client },
        actions: {
            play: resume,
            pause: pause,
            update: {
                run: update,
                pending: track.update.pending,
            },
        },
    };
};
